<div class="form-group">
  <label
    *ngIf="!hideLabel && labelTranslateKey?.length > 0"
    class="label"
    [ngClass]="{ required: isInputControlRequired() }"
    [for]="labelTranslateKey">
    {{ labelTranslateKey | translate }}
  </label>

  <div
    class="input-group stepper"
    [class.input-group-sm]="compact"
    [ngClass]="{ 'is-invalid': isInputControlInvalid() }">
    <button
      type="button"
      class="btn stepper-btn stepper-btn--minus"
      (click)="decrement()"
      [disabled]="isDecrementDisabled()">
      -
    </button>

    <input
      type="number"
      class="form-control stepper-input"
      [readOnly]="readonly"
      [placeholder]="
        placeholderTranslateKey
          ? (placeholderTranslateKey | translate)
          : ('APPLICATION.FORM.enterPlaceholderText' | translate: { placeholder: labelTranslateKey | translate | lowercase })
      "
      [formControl]="inputControl"
      [id]="labelTranslateKey"
      [name]="labelTranslateKey"
      [ngClass]="{ 'is-invalid': isInputControlInvalid() }"
      [min]="min"
      [max]="max"
      [step]="step"
      [appOnlyDecimal]="allowDecimals"
      [appOnlyPositive]="onlyPositives" />

    <button
      type="button"
      class="btn stepper-btn stepper-btn--plus"
      (click)="increment()"
      [disabled]="isIncrementDisabled()">
      +
    </button>
  </div>

  <app-validation-message
    [field]="inputControl"
    displayName="{{ labelTranslateKey | translate | lowercase }}">
  </app-validation-message>
</div>
